export default "93998af737209425.png"